<template>
    <div> <a-tabs  @change="tabsChange" >
        <a-tab-pane key="1" tab="批量翻译">
            <TranslateAll ref="TranslateAll"/>
        </a-tab-pane>
        <a-tab-pane key="2" tab="翻译日志">
            <TranslationLog ref="TranslationLog"/>
        </a-tab-pane>
    </a-tabs></div>
</template>

<script>
    import TranslateAll from "./components/translateAll"
    import TranslationLog from "./components/translationLog"
    export default {
        name: "index",
        data(){
            return{

            }
        },
        components:{TranslateAll,TranslationLog},
        created() {
            this.$store.state.adminleftnavnum = "/BatchTranslation/NewsClass"; //设置左侧导航2-2 active
        },
        methods:{
            tabsChange(data){
                if(data==1){
                    console.log(this.$refs['TranslateAll'].seach)
                    if(this.$refs['TranslateAll'].seach.a_customer_id){
                        this.$refs['TranslateAll'].getList()
                    }
                }else{
                    setTimeout(()=>{
                        if(this.$refs['TranslationLog'].seach.a_customer_id){
                            this.$refs['TranslationLog'].getList()
                        }
                    },100)
                }
            }
        }
    }
</script>

<style scoped>

</style>